import ChartsThemeProvider, { useChartTheme } from './ChartsThemeProvider';
import ThemeProvider from './ThemeProvider';

export { ChartsThemeProvider, useChartTheme };

export default ThemeProvider;
